import { storeToRefs } from 'pinia';
import { useWindowSize } from '@vueuse/core';
import { anchorNavStore } from '~/stores/anchorNav';

import type { AnchorNavOptions } from '~~/types/product/AnchorNav';

export default function () {

  const store = anchorNavStore();
  const { activeSection } = storeToRefs(store);

  const stickyAnchorNavHeight = computed(() => store.stickyAnchorNavHeight || 0);
  const { height: windowHeight } = useWindowSize();
  const observerRootMargin = computed(() =>
    `-${stickyAnchorNavHeight.value}px 0px -${windowHeight.value - stickyAnchorNavHeight.value}px 0px`,
  );

  const setActiveSection = (id: AnchorNavOptions | null) => {

    store.setActiveSection(id);
  
  };

  const setStickyAnchorNavHeight = (height: number) => {

    store.setStickyAnchorNavHeight(height);
  
  };

  return {
    ...store,
    setActiveSection,
    setStickyAnchorNavHeight,
    activeSection,
    stickyAnchorNavHeight,
    observerRootMargin,
  };

}